import { jsxs, jsx } from 'react/jsx-runtime';
import { useModelCompareTranslation } from '../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { StyleableSvgImage } from '../../../../StyleableSvgImage/StyleableSvgImage.mjs';
import { Container, Buttons, Button, ButtonCopy } from './ButtonGroup.styles.mjs';
"use strict";
const ButtonGroup = ({
  items,
  activeButton,
  onClick
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const spotlightItems = items.filter(item => item?.isSpotlightGroup);
  const normalItems = items.filter(item => !item?.isSpotlightGroup);
  return /* @__PURE__ */jsxs(Container, {
    children: [spotlightItems.length > 0 && /* @__PURE__ */jsx(Buttons, {
      $isSpotlight: true,
      children: spotlightItems.map(item => item ? /* @__PURE__ */jsxs(Button, {
        id: `${item.id}-tab`,
        $isActive: item.id === activeButton,
        onClick: () => onClick(item.id),
        children: [/* @__PURE__ */jsx(StyleableSvgImage, {
          src: item.icon.src,
          width: item.icon.width,
          height: item.icon.height
        }), /* @__PURE__ */jsx(ButtonCopy, {
          children: formatMessage(item.title)
        })]
      }, item.id) : null)
    }), /* @__PURE__ */jsx(Buttons, {
      children: normalItems.map(item => item ? /* @__PURE__ */jsxs(Button, {
        id: `${item.id}-tab`,
        $isActive: item.id === activeButton,
        onClick: () => onClick(item.id),
        children: [/* @__PURE__ */jsx(StyleableSvgImage, {
          src: item.icon.src,
          width: item.icon.width,
          height: item.icon.height
        }), /* @__PURE__ */jsx(ButtonCopy, {
          children: formatMessage(item.title)
        })]
      }, item.id) : null)
    })]
  });
};
export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.mjs.map
